<template>
  <div class="modal-overlay"><BasePreloader /></div
></template>

<script>
export default {}
</script>

<style lang="scss">
.modal-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(221, 247, 255);
}
</style>



// WEBPACK FOOTER //
// components/modals/AppPreloaderModal.vue